import {Component, Inject} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TuiDialogContext} from '@taiga-ui/core';
import {POLYMORPHEUS_CONTEXT} from '@taiga-ui/polymorpheus';
import {LegalRepresentative} from '@gatewee/types/person';
import {partnerRoleOptions} from '@gatewee/types/onboarding';

export interface PartnerFormDialogData {
  formGroup: FormGroup;
}

@Component({
  selector: 'app-partner-form',
  templateUrl: './partner-form.component.html',
  styleUrls: ['./partner-form.component.css'],
  standalone: false,
})
export class PartnerFormComponent {
  constructor(
    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<
      LegalRepresentative | false,
      PartnerFormDialogData
    >,
  ) {}

  partnerStepIndex = 0;
  readonly partnerLastStepIndex = 3;

  get formGroup(): FormGroup {
    return this.context.data.formGroup;
  }

  get AddressFormGroup(): FormGroup {
    return this.formGroup.get('address') as FormGroup;
  }

  roles = partnerRoleOptions;

  isStepValid(fields: string[]): boolean {
    return fields.every(field => this.formGroup.get(field)?.valid);
  }

  nextPartnerStep(): void {
    if (this.partnerStepIndex < this.partnerLastStepIndex) {
      this.partnerStepIndex++;
    }
  }

  previousPartnerStep(): void {
    if (this.partnerStepIndex > 0) {
      this.partnerStepIndex--;
    }
  }

  canAdvanceFromCurrentStep(): boolean {
    switch (this.partnerStepIndex) {
      case 0:
        return this.isStepValid(['name', 'document', 'email', 'phone']);
      case 1:
        return this.isStepValid(['birthDate']);
      case 2:
        return this.AddressFormGroup.valid;
      case 3:
        return this.isStepValid([
          'partnerSharePercentage',
          'politicallyExposedPerson',
          'role',
        ]);
      default:
        return false;
    }
  }

  close(): void {
    this.context.completeWith(false);
  }

  submit(): void {
    if (this.formGroup.valid) {
      this.context.completeWith(this.formGroup.value as LegalRepresentative);
    } else {
      this.formGroup.markAllAsTouched();
    }
  }
}
